import httpClient from '@src/services/http.service'

export const state = {
  isLoading: false,
  pageData: {}
}

export const actions = {
  init: ({ commit }) => {
    commit('loadingState', { isLoading: true })
    httpClient.get('pages/5fe20f8f8d1f870bd2413ec4')
      .then(response => {
        commit('SET_PAGE_DATA', response.data)
        commit('loadingState', { isLoading: false })
      })
      .catch(error => {
        commit('SET_ERROR', error.message)
      })
  },
}

export const mutations = {
  SET_PAGE_DATA: (state, pageData) => {
    state.pageData = pageData
  },

  loadingState (state, { isLoading }) {
    state.isLoading = isLoading
  },
}

export const getters = {
  pageData: state => state.pageData,
  isLoading: state => state.isLoading,
  // appLinks: state => state.pageData ? state.pageData.plan_content[0].urls : []
  appLinks: state => state.pageData.plan_content[0].urls
}
